import { IndustrialCaseMediaCaption } from './IndustrialCaseMediaCaption';

type IndustrialCaseVideoPlayerProps = {
  /**
   * ### caption
   *
   * Author-written explanation shown below the video.
   */
  caption: string;
  /**
   * ### src
   *
   * Browser-playable MP4 URL emitted by the authoring upload flow.
   */
  src: string;
};

/**
 * ### IndustrialCaseVideoPlayer
 *
 * Renders an authored video with explicit controls and reserved aspect ratio.
 * Playback never starts automatically, preserving user intent and data usage.
 *
 * @param props Uploaded video metadata
 * @returns Accessible customer-case video figure content
 */
export function IndustrialCaseVideoPlayer({
  caption,
  src,
}: IndustrialCaseVideoPlayerProps) {
  const accessibleLabel = caption.trim() || '고객사례 동영상';

  return (
    <figure className="case-media case-media--video">
      <div className="overflow-hidden rounded-[2px] border border-[#d8d8d3] bg-[#171715]">
        {/* Customer-case inspection footage is uploaded without spoken audio. */}
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          className="block aspect-video w-full bg-black object-contain"
          aria-label={accessibleLabel}
          controls
          playsInline
          preload="metadata"
          src={src}
        >
          브라우저에서 이 동영상을 재생할 수 없습니다
        </video>
      </div>
      <IndustrialCaseMediaCaption caption={caption} />
    </figure>
  );
}
